<template>
    <div>
		<el-alert type="warning" :closable="false">
		    <div slot="title">		        
		        <router-link to="/operation/banner/list" class="color-danger">切换到列表视图<i class="el-icon-right"></i></router-link>
		    </div>
		</el-alert>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="BannerID" :value="1"></el-option>
                            <el-option label="Banner名称" :value="2"></el-option><!-- 
                            <el-option label="展示城市" :value="3"></el-option> -->
                        </el-select>
                    </el-input>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.cityCode" :filterable="true" :multiple="false" :clearable="true" placeholder="请选择" size="small">
					    <el-option-group v-for="item in cityOptions" :key="item.label" :label="item.label">
					        <el-option v-for="cld in item.children" :key="cld.value" :label="cld.label" :value="cld.value"></el-option>
					    </el-option-group>
					</el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="12" :xl="2">
					<el-select v-model="params.queryTimeType" size="small" placeholder="请选择">
						<el-option label="展示时间" :value="1"></el-option>
						<el-option label="展示起始时间" :value="2"></el-option>
					</el-select>					
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						  size="small"
					      v-model="params.startTime"
					      type="datetime"
					      placeholder="开始日期"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  >
					    </el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="4" >
					<el-date-picker
						 size="small"
					      v-model="params.endTime"
					      type="datetime"
					      placeholder="结束日期"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  >
					    </el-date-picker>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-select v-model="params.category" placeholder="不限制位于首页分类的位置" class="fl fl-big-select" clearable size="small">
						<el-option v-for="(item, index) in category"  :label="item.name == '推荐' ? '位于首页推荐分类' : '仅看位于首页'+item.name+'分类的' " :key="index" :value="item.id"></el-option>
					</el-select>
				 </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="12" :xl="2">
                    <el-select v-model="params.isShow" placeholder="请选择" size="small">
                        <el-option label="仅看展示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="2"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="12" :xl="3">
                    <el-select v-model="params.terminal" placeholder="请选择" size="small">
                        <el-option label="仅看APP的" :value="3"></el-option>
                        <el-option label="仅看WAPCN的" :value="2"></el-option>
                        <el-option label="仅看WAPEN的" :value="4"></el-option>
                        <el-option label="仅看WEB的" :value="1"></el-option>
                        <el-option label="不限制展示终端" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button
                v-if="$utils.have('/banner/getDetail')"
                type="primary"
                icon="el-icon-plus"
                @click="add"
                size="small"
                >创建Banner</el-button
            >            
        </div>
        <div class="page-list-box">
            <div class="fullCalendarCont">                  
				 <el-calendar>				   
				   <template
				     slot="dateCell"
				     slot-scope="{date, data}"
					 >					 
				     <div class="list">
						 <div class="el-icon-circle-plus-outline add" @click="addCalendar(data.day)"></div>
						<div class="calendarTime"> {{ data.day.slice(8) }}</div>
						<div v-if="calendarData && calendarData.length > 0" >
							<div class="calendarList" v-for="(item,index) in calendarData" :key="index"  v-if="data.day==item.time">								
								<router-link v-for="(its,ids) in item.detailList.slice(0,3)" :key="ids" :class="['text', its.isShow == 1 ? '' : 'hidden']" 
								:to="`/operation/banner/detail/${its.id}`" >
									{{its.timeView}} <span class="title">{{its.title}}</span>
								</router-link>							
								<el-popover
								  placement="right"
								  width="500"								 
								  :ref="'pop' + index"
								  trigger="click">								  
								  <div class="currentTime">当前日期：{{ data.day }} {{week}}<div class="close" @click="closePop(index)"><span class="el-icon-close"></span></div></div>
								  <div class="currentTime">Banner安排：</div>
								  <el-table :data="item.detailList" class="miniTable">
									<el-table-column  label="状态">
										<template slot-scope="scope">
										    <p v-if="scope.row.isShow === 1">展示</p>
										    <p v-else-if="scope.row.isShow === 2">隐藏</p>
										</template>
									</el-table-column>
									<el-table-column  property="timeView" label="时间" min-width="120"></el-table-column>
									<el-table-column property="id" label="ID"></el-table-column>
									<el-table-column min-width="200" label="名称">
										<template slot-scope="scope">
											<router-link  :to="`/operation/banner/detail/${scope.row.id}`" >{{scope.row.title}}</router-link>
										</template>
									</el-table-column>
								  </el-table>								 
								  <div class="more" v-if="item.detailList.length >3 " slot="reference" @click="getweek(data.day)">+还有{{item.detailList.length - 3}}项</div>
								</el-popover>
							</div>
						</div>					   
				     </div>
				   </template>
				 </el-calendar>
              </div>
        </div>
        
    </div>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'

const defaultQuery = {
    pageNo: 1,
    endTime: '',
    startTime: '',
    queryTimeType: 1,
    queryType: 1,
    queryValue: '',
    terminal: '',
    isShow: 1,
	cityCode:[],
	category:''
};
export default {
   components: { },
    data() {
        return {
            visible: false,
            params: {
                ...defaultQuery,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                // startTime: this.$route.query.startTime || '',
                // endTime: this.$route.query.endTime || '',
                queryTimeType: parseInt(this.$route.query.queryTimeType || 1),
                queryType: parseInt(this.$route.query.queryType || 1),
                queryValue: this.$route.query.queryValue || '',
                terminal: parseInt(this.$route.query.terminal)|| '',
                isShow: parseInt(this.$route.query.isShow)|| 1,
				cityCode: parseInt(this.$route.query.cityCode)|| 10,
				category: parseInt(this.$route.query.category)|| '',
            },
           // datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
            fetchLoading: false,
            calendarData: [],
            //totalCount: 0,
			cityOptions:[],
			week:'',
			category:[],
			
			
			
        };
    },
    mounted(){        
		
    },
	created(){
		this.fetch();
		this.fetchCity();
		this.getCategory()
	},
    methods: {		
		getweek(day){
			this.week = ''
			let date = new Date(Date.parse(day.replace(/-/g,"/")));
			let wk = date.getDay() 
			let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
			let week = weeks[wk]
			this.week = week
		},
		closePop(index){
		  let ref = 'pop' + index;
		  this.$refs[ref][0].doClose();
		},
		// 获取城市
		async fetchCity() {
		    const res = await fetchAllCity().catch(() => {
		        return {data: {state: '0', msg: '请求错误'}};
		    });
		    const { state , result } = res.data;
		    if(state !== '1') {
		        return ;
		    }
		    const cityOptions = (result || []).map(item => {
		        return {
		            label: item.name, 
		            children: (item.cityList || []).map(({id, name}) => ({label: name, value: id}))
		        }
		    });
		    cityOptions.unshift({label: '所有城市', children: [{label: '全国', value: 0}]});
		    this.cityOptions = cityOptions;
		},
		addCalendar(data){

			this.$router.push({
			    path:`/operation/banner/addCalendar/${data}`,
			    query: {
			        redirect: this.$utils.objArgs(
			            this.$router.currentRoute.path,
			            this.params
			        ),
			    },
			});
		},
		//获取演出分类
		getCategory() {
		    this.$request({
		        url: "/banner/category",
		        method: "post",
		        
		    }).then(res => {
		        const { state, result } = res.data;
		        if (state == 1) {
		            this.category = result || []
		        }
		    })
		},
        async fetch() {
			if( this.$utils.compareDate(this.params.startTime, this.params.endTime) ){
			    return this.$message.error("开始时间不能大于等于结束时间");
			}
			this.fetchLoading = true;
            const response = await this.$request({
                url: "/banner/monthlyCalendar",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
            const {state, msg, result} = response.data;
            this.fetchLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.calendarData = result;
			
			
            //this.totalCount = result.totalCount;
        },
        async setTop (id, type) {
            const response = await this.$request({
                url: '/banner/setAsNationalSort',
                params: {id, type},
            });
            const {msg, state} = response.data;
            this.btnLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.$message.success('操作成功');
            this.fetch();
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.fetch();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.fetch();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultQuery,
                pageSize: this.params.pageSize,
				cityCode:10
            };
            this.fetch();
        },
        add(){
            this.$router.push('/operation/banner/add');
        },
        edit(id){
            this.$router.push({
                path:`/operation/banner/detail/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        }
    },
};
</script>
<style lang="scss" scoped>
	::v-deep .el-calendar-day{
		min-height: 100px;
		height: 100%;		
	}
	::v-deep .el-calendar__title{
		font-size: 24px;
	}
	::v-deep .el-calendar-table thead th{
		font-size: 24px;
	}
	::v-deep .el-calendar-table td.is-today{
		background-color: #1FBB7D;
		color:#FFF;
		.calendarTime{
			color:#FFF
		}
		
	}
	::v-deep .el-calendar-table td.is-today .el-calendar-day:hover {
	    background-color: #1FBB7D !important;
	    color: #FFF;
		.calendarTime{
			color:#FFF
		}
		.calendarList{
			padding-top:15px;
			color:#333;
			.text{
				color:#333;
				display: block;
				padding-bottom: 3px;
				font-size:10px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&:hover{
					color:#FFF
				}
				&.hidden{
					text-decoration: line-through;
					color:#C0C4CC;
				}
				.title{
					color:#333;
					font-weight: bold;
					font-size: 12px;
					&:hover{
						color:#FFF
					}
				}
			}
			.text:hover .title{
				color:#fff
			}
		}
	}
	::v-deep .el-calendar-table{
		width: 100%;
		height: 100%;
		&:not(.is-range){
			//使不是本月的日期不可点击，不会跳转到其他月份
			td.next{
				pointer-events: none;
				.calendarTime{
					color:#C0C4CC
				}
			}
			td.prev{
				pointer-events: none;
				.calendarTime{
					color:#C0C4CC
				}
				.list .add{
					opacity: 0;
				}
				.list .more{
					opacity: 0;
				}
			}
			
		}
	}
	.miniTable{
		border:1px solid #EBEEF5;
		font-size: 12px;
		height: 400px;
		overflow-y:auto;
		margin-bottom: 20px;
	}
	.currentTime{
		font-size: 16px;
		padding: 15px 0;
		font-weight: bold;
		position: relative;
		.close{
			position: absolute;
			right:0;
			top:0;
			width:15px;
			height:15px;
			cursor: pointer;
			span{
				display: inline-block;
				width: 15px;
				height: 15px;
			}
		}
	}
	.list{
		position: relative;
		.add{
			position: absolute;
			right: 0;
			top: 0;			
		}
		.calendarTime{
			font-size:24px;
			color:#000;
			font-weight: bold;
		}
		.calendarList{
			padding-top:15px;			
			.text{
				display: block;
				padding-bottom: 3px;
				font-size:10px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				&.hidden{
					text-decoration: line-through;
					color:#C0C4CC
				}
				.title{
					
					font-weight: bold;
					font-size: 12px;
				}
			}
		}
		.more{
			color:#1FBB7D;
			margin-top: 15px;			
			text-align: left;
			height: 25px;
			line-height: 25px;
			
		}
	}
</style>
